import { isGovCloud, isPCE } from './environments'
import * as React from 'react'
import {
  SupportedRuntimes, supportedRuntimesText,
  SupportedRuntimesTooltip
} from '@mulesoft/monitoring-center-components/lib/components/SupportedRuntimesHelper/SupportedRuntimesHelper'

export const supportedRuntimesTextForGOV = 'Anypoint Monitoring currently supports Mule versions 3.9.x , 4.x .'

export const supportedRuntimesTextForPCE = 'Anypoint Monitoring supports Mule 3 (3.9.3 and above) and Mule 4 (4.1.6 and above)'

export const getSupportedRuntimesText = () => {
  if (isPCE())  {
    return supportedRuntimesTextForPCE
  }
  if (isGovCloud()) {
    return supportedRuntimesTextForGOV
  }
  return supportedRuntimesText
}

export const supportedRuntimesTooltip = () => {
  if (isPCE())  {
    return SupportedRuntimes(supportedRuntimesTextForPCE)
  }
  if (isGovCloud()) {
    return SupportedRuntimes(supportedRuntimesTextForGOV)
  }
  return <SupportedRuntimesTooltip/>;
}

export const SupportedRuntimesTooltipResolver = () => supportedRuntimesTooltip()
